import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  OrganisationsQuery,
  OrganisationsQueryVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const organisationsQuery = graphql(`
  query organisations($ids: [String!]!) {
    organisations(ids: $ids) {
      id
      name
      url
      email
      phone
      address
      town
      postalCode
      primaryRole
    }
  }
`);

/**
 * Resolves organisation guids straight from the DB, for callers holding a stored id rather than
 * running a search — a document's uploaded-for org, a report's subject, a guid out of the URL.
 *
 * Not interchangeable with `useOrganisations`. That one resolves its ids through the organisations
 * index, which holds no deleted orgs, so a guid whose org has since been merged away resolves here
 * and comes back empty there. It also returns nothing at all to a user without feed settings,
 * where this query has no such gate.
 */
export function useOrganisationsByIds(
  ids: OrganisationsQueryVariables["ids"],
  options?: UseQueryOptions<OrganisationsQuery, unknown, OrganisationsQuery, QueryKey>,
) {
  return useGraphQlQuery(["organisationsByIds", ids], organisationsQuery, [{ ids }], {
    ...options,
  });
}
